<template>
  <div data-testid="add-filter">
    <autocomplete
            :label="'label'"
            :clear_on_select="true"
        @select="add_filter"
        :placeholder="$t('settings_tasks.edit_filter_tree_placeholder')"
        :options="options"></autocomplete>
  </div>
</template>

<script>
import Autocomplete from "@/components/Autocomplete";
export default {
  name: "AddFilter",
  components: {Autocomplete},
  props: {
    'initial_filter': {default: false}
  },
  data () {
    return {
      options: [],
      selected_option: false,
    }
  },
  methods: {
    add_filter(selected_option) {
      if (selected_option == null) {
        return;
      }
      let filterToAdd = null;
      if (typeof selected_option === 'object') {
        filterToAdd = selected_option;
      } else {
        filterToAdd = this.options.find((option) => option.label === selected_option) || null;
      }
      if (!filterToAdd) {
        return;
      }
      this.$emit('add_filter', JSON.parse(JSON.stringify(filterToAdd)));
      this.selected_option = false;
    },
    async load_filter_options() {
      const data = await this.$api.asset.filter_options();
      const options = Array.isArray(data) ? data : [];
      this.options = options;
      if (Array.isArray(this.initial_filter) && this.initial_filter.length > 0) {
        this.initial_filter.forEach(initial_filter=> {
          let related_filters = options.filter((f) => { return initial_filter.type == f.type });
          if(related_filters.length>0) {
            let to_add = JSON.parse(JSON.stringify(related_filters[0]))

            if(initial_filter.value) {
              to_add.value = initial_filter.value;
            }
            this.$emit('add_filter', to_add)
          }
        })
      }
    }
  },
  mounted() {
    this.load_filter_options()
  }
}
</script>

<style scoped>

</style>